import {
  TALL_BUTTON_HEIGHT,
  SMALL_BUTTON_HEIGHT,
  DEFAULT_INLINE_BUTTON_HEIGHT,
  EXTRA_SMALL_BUTTON_HEIGHT,
} from 'ui/theme/constants'

export const buttonHeights = {
  extraSmall: EXTRA_SMALL_BUTTON_HEIGHT,
  tall: TALL_BUTTON_HEIGHT,
  small: SMALL_BUTTON_HEIGHT,
  inline: DEFAULT_INLINE_BUTTON_HEIGHT,
} as const
